import React from "react";

/**
 * GoogleSignInButton — kicks off the Emergent-managed Google OAuth flow.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH. The redirect_url is derived synchronously from
 * `window.location.origin` so the user always returns to the same domain
 * they clicked from (preview vs. production).
 *
 * After Google auth the user lands back at `<origin>/#session_id=<one_time>`.
 * `AuthCallback` (mounted in App.js when the hash is detected) exchanges the
 * session_id server-side.
 */
export default function GoogleSignInButton({ label = "Continue with Google", testid = "google-signin-btn", disabled = false }) {
  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
    // THIS BREAKS THE AUTH.
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={start}
      disabled={disabled}
      data-testid={testid}
      className="w-full h-11 rounded-xl border border-zinc-300 bg-white hover:bg-zinc-50 hover:border-zinc-400 disabled:opacity-60 disabled:cursor-not-allowed transition-colors inline-flex items-center justify-center gap-2.5 text-[13.5px] font-semibold text-zinc-800 shadow-sm"
    >
      <GoogleGlyph />
      {label}
    </button>
  );
}

function GoogleGlyph() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden>
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32.1 29.4 35 24 35c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.1 5.1 29.3 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21c0-1.2-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.1 5.1 29.3 3 24 3 16.3 3 9.7 7.5 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 45c5.2 0 10-2 13.5-5.2l-6.2-5.3C29.4 36.4 26.9 37 24 37c-5.3 0-9.8-2.9-11.3-7l-6.5 5C9.6 40.5 16.2 45 24 45z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.2 5.3C41 34.3 45 29.6 45 24c0-1.2-.1-2.3-.4-3.5z"/>
    </svg>
  );
}
